import { z } from '@betty/toolkit/api';

export const GameplaySchema = z.object({
  url: z.string(),
  provider: z.string(),
});
